import { render } from "./GenericRadioList.vue?vue&type=template&id=67bbad04"
import script from "./GenericRadioList.vue?vue&type=script&lang=js"
export * from "./GenericRadioList.vue?vue&type=script&lang=js"
script.render = render

export default script